import React from 'react';

import { TertiaryButton } from '../../shared/Buttons/TertiaryButton';
import { Flags } from '../../shared/Flags/Flags';
import { type Locale } from '../../../store/i18nSlice';

interface LocaleDropdownItemProps {
  readonly locale: Locale;
  readonly type: string;
  readonly selected: boolean;
  readonly onClick: (locale: Locale) => void;
}

export const LocaleDropdownItem = ({ locale, type, selected, onClick }: LocaleDropdownItemProps) => {
  return (
    <div className={selected ? 'selected-item' : ''}>
      <TertiaryButton
        data-testid={`dropdown-language-item-${type}`}
        className="full-width text-black"
        onClick={() => onClick(locale)}
        shape="squared"
        endSlot={<Flags lang={locale.country.toLowerCase()} />}
        role="menuitem"
        aria-current={selected ? 'true' : undefined}
      >
        <span className="no-wrap">
          {locale.language} ({locale.country})
        </span>
      </TertiaryButton>
    </div>
  );
};
